// @mui
import { Box, BoxProps, Stack, useTheme } from "@compass/core";
import { UserSetting } from "components";
import { AppTopBarBrand } from "./AppTopBarBrand";
import { AppTopBarNavTrigger } from "./AppTopBarNavTrigger";
import { AppTopBarSearch } from "./AppTopBarSearch";
import { AppTopBarUserMenu } from "./AppTopBarUserMenu";
import { useMediaQuery } from "@mui/material";

export const AppTopBar = () => {
  const theme = useTheme();
  const showSearch = useMediaQuery(theme.breakpoints.up("sm"));

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      position="relative"
      px={3}
      py={1}
      bgcolor={theme.palette.background.default}
      //borderBottom={1}
    >
      <Stack direction="row" spacing="sm" alignItems="center">
        <AppTopBarNavTrigger />

        <AppTopBarBrand />

        {showSearch && (
          <Box pl={3}>
            <AppTopBarSearch />
          </Box>
        )}

        {/* <Box pl={5}>{renderBreadcrumbs()}</Box> */}
      </Stack>

      <Stack direction="row" alignItems="center" spacing="sm">
        {/* <UserSetting /> */}

        <AppTopBarUserMenu />
      </Stack>
    </Stack>
  );
};
